import { Panel } from '../../panels/panel.class';
import { PanelItem } from '../panel-item.class';
import { Size } from '../../../types';

export const getSizeCfn = (panelItem: PanelItem, panel: Panel): Size => {
	const itemSize: Size = {
		width: panelItem.item.size.width + (panelItem.sidePadding ?? 0),
		height: panelItem.isDropIn
			? panelItem.item.distanceAboveCountertop + (panelItem.item.distanceBelowCountertop || 0)
			: panelItem.item.size.height,
		depth: panelItem.item.size.depth
	};

	return itemSize;
};
